// import {useState,useEffect} from "react";
// import { Link } from "react-router-dom"; // 1. Import Link
// import "./Footer.css";
// import images from "../../Utils/Images";
// import { PopupButton } from "react-calendly";

// // 2. Define links as objects with names and paths
// const businessLinks = [
//   { name: "Business", path: "/business" },
//   { name: "Careers", path: "/careers" },
//   { name: "Membership", path: "/membership" },
//   { name: "Locations", path: "/locations" },
//   { name: "Terms & Conditions", path: "/terms" },
// ];

// const companyLinks = [
//   { name: "About", path: "/about" },
//   { name: "FAQ'S", path: "/faqs" },
//   { name: "Contact Us", path: "/contact" },
//   { name: "Privacy Policy", path: "/privacy" },
// ];

// const Footer = () => {

//   const [popupOpen, setPopupOpen] = useState(false);

//     useEffect(() => {
//       document.body.style.overflow = popupOpen ? "hidden" : "auto";
//       return () => {
//         document.body.style.overflow = "auto";
//       };
//     }, [popupOpen]);

//   return (
//     <footer className="footer">
//       <div className="footerContainer">
//         <div className="footerCol">
//           <div className="logoContainer">
//             <Link to="/">
//               <img
//                 src={images.logo}
//                 alt="Softations Logo"
//                 className="logo-svg"
//               />
//             </Link>
//             <span className="logoText">Softations</span>
//           </div>
//           <p className="description">
//             Softations is a tech-driven company specializing in innovative,
//             user-focused software solutions. We transform complex ideas into
//             seamless digital experiences across web, mobile, and enterprise
//             platforms. With a commitment to quality, creativity, and smart
//             technology, we help businesses grow through scalable, future-ready
//             solutions.
//           </p>
//         </div>

//         <div className="footerColLinks">
//           <div className="group">
//             {businessLinks.map((item, index) => (
//               <Link to={item.path} key={index} className="link">
//                 {item.name}
//               </Link>
//             ))}
//           </div>
//           <div className="group">
//             {companyLinks.map((item, index) => (
//               <Link to={item.path} key={index} className="link">
//                 {item.name}
//               </Link>
//             ))}
//           </div>
//         </div>

//         <div className="footerContact">
//           <PopupButton
//                 url="https://calendly.com/admin-softations/meet-softations-to-turn-your-idea-into-reality"
//                 rootElement={document.getElementById("root")}
//                 text="Request a Call"
//                 className="reqBtn"
//                 onClick={() => setPopupOpen(true)}
//                 onModalClose={() => setPopupOpen(false)}
//               />

//           <div className="contactDetails">
//             <span className="contactItem">+92 333-3333-33-1</span>
//             <a href="mailto:info@softations.com" className="contactItem">
//               info@softations.com
//             </a>
//           </div>
//         </div>
//       </div>
//     </footer>
//   );
// };

// export default Footer;


import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import TechIcon from "../../Utils/Icons/Icons";
import "./Footer.css";
import images from "../../Utils/Images";
import { PopupButton } from "react-calendly";

const Footer = () => {
  const [popupOpen, setPopupOpen] = useState(false);

  useEffect(() => {
    document.body.style.overflow = popupOpen ? "hidden" : "auto";
    return () => (document.body.style.overflow = "auto");
  }, [popupOpen]);

  return (
    <footer className="footer">
      <div className="footerContainer">
        <div className="footerBrand">
          <div className="brandHeader">
            <img src={images.logo} alt="Softations Logo" />
            <h2>Softations</h2>
          </div>

          <p className="brandDesc">
            We build scalable, high-performance digital solutions that help
            businesses grow through technology, design, and innovation.
          </p>

          <p className="brandLocation">
            <a
              href="https://maps.google.com/?cid=8668475316244543589&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQ"
              target="_blank"
              rel="noopener noreferrer"
            >
              Softations, GT, 2nd floor Allied Bank Plaza, GTS Chowk Road,
              Gujrat.
            </a>
          </p>
        </div>

        <div className="footerLinks">
          <Link to="/careers" className="footerLink">
            <TechIcon name="briefcase" size={20} />
            <span>Careers</span>
          </Link>

          <Link to="/contact" className="footerLink">
            <TechIcon name="email" size={20} />
            <span>Contact Us</span>
          </Link>

          <a
            href="https://www.google.com/maps/dir//GT,+2nd+floor+Allied+Bank+Plaza,+GTS+chowk,+Road,+Gujrat/@32.5581726,74.0630682,15z/data=!4m8!4m7!1m0!1m5!1m1!1s0x391f1b835dfac699:0x784c9c5f60ff7865!2m2!1d74.0721359!2d32.5690333?entry=ttu"
            target="_blank"
            rel="noopener noreferrer"
            className="footerLink"
          >
            <TechIcon name="map" size={20} />
            <span>Location</span>
          </a>
        </div>

        <div className="footerContact">
          <PopupButton
            url="https://calendly.com/admin-softations/meet-softations-to-turn-your-idea-into-reality"
            rootElement={document.getElementById("root")}
            text="Request a Call"
            className="reqBtn"
            onClick={() => setPopupOpen(true)}
            onModalClose={() => setPopupOpen(false)}
          />

          <div className="contactInfo">
            <a
              href="https://wa.me/923009439213"
              target="_blank"
              rel="noreferrer"
            >
              +92 300 9439213
            </a>
            <a href="mailto:admin@softations.com">admin@softations.com</a>
          </div>
        </div>
      </div>

      <div className="footerBottom">
        © {new Date().getFullYear()} Softations. All rights reserved.
      </div>
    </footer>
  );
};

export default Footer;
